import {useEffect} from 'react'

import Loading from '../../common/components/List/Loading.js'
import {refreshMOList} from './moListActions.js'
import {moListQuerySelector, isLoadingSelector} from './moListSelectors.js'
import MOListFooter from './MOListFooter.js'
import Table from './Table.js'
import {useSelector} from '../../store.js'

export default function List() {
  const params = useSelector(moListQuerySelector)
  const isLoading = useSelector(isLoadingSelector)

  useEffect(() => {
    refreshMOList()
  }, [params])

  return (
    <>
      {isLoading ? (
        <div className="medium-12 columns list--empty-content margin-top-40 margin-bottom-40">
          <Loading />
        </div>
      ) : (
        <div className="medium-12 columns">
          <Table />
          <MOListFooter />
        </div>
      )}
    </>
  )
}
